import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | null | undefined, showNever?: boolean, shortFormat: boolean = false): string {
    if (!value) {
      return showNever ? 'Never' : ''; // or return an empty string if you prefer
    }

    const currentDate = new Date();
    const pastDate = new Date(value);
    if (isNaN(pastDate.getTime())) {
      return 'Invalid date'; // Handle cases where date conversion fails
    }

    const seconds = Math.max(0, Math.floor((currentDate.getTime() - pastDate.getTime()) / 1000));

    let interval = seconds / 31536000;
    if (interval > 1) {
      const unit = shortFormat ? 'y' : ' year' + (Math.floor(interval) > 1 ? 's' : '');
      return Math.floor(interval) + unit + (shortFormat ? '' : ' ago');
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      const unit = shortFormat ? 'mo' : ' month' + (Math.floor(interval) > 1 ? 's' : '');
      return Math.floor(interval) + unit + (shortFormat ? '' : ' ago');
    }
    interval = seconds / 86400;
    if (interval > 1) {
      const unit = shortFormat ? 'd' : ' day' + (Math.floor(interval) > 1 ? 's' : '');
      return Math.floor(interval) + unit + (shortFormat ? '' : ' ago');
    }
    interval = seconds / 3600;
    if (interval > 1) {
      const unit = shortFormat ? 'h' : ' hour' + (Math.floor(interval) > 1 ? 's' : '');
      return Math.floor(interval) + unit + (shortFormat ? '' : ' ago');
    }
    interval = seconds / 60;
    if (interval > 1) {
      const unit = shortFormat ? 'm' : ' minute' + (Math.floor(interval) > 1 ? 's' : '');
      return Math.floor(interval) + unit + (shortFormat ? '' : ' ago');
    }
    const unit = shortFormat ? 's' : ' second' + (Math.floor(seconds) > 1 ? 's' : '');
    return Math.floor(seconds) + unit + (shortFormat ? '' : ' ago');
  }
}